/**
 * Client-view local analytics event names (cross-product).
 */

export const CLIENT_VIEW_GEOLOCATION_EVENTS = {
  REQUESTED: "geolocation_requested",
  GRANTED: "geolocation_granted",
  DENIED: "geolocation_denied",
  UNAVAILABLE: "geolocation_unavailable",
};
